const build = `<Project Sdk="Microsoft.NET.Sdk.Web">

  <PropertyGroup>
    <TargetFramework>netcoreapp3.1</TargetFramework>
    <RootNamespace>StripeExample</RootNamespace>
  </PropertyGroup>

  <ItemGroup>
  <PackageReference Include="Microsoft.AspNetCore.Mvc.NewtonsoftJson" Version="3.1.3" />
  <PackageReference Include="Stripe.net" Version="39.*" />
  </ItemGroup>

</Project>
`;

export default {
  build,
};
